import styled, { css } from 'styled-components';

export const HOVER_PARENT_CLASSNAME = 'hover_parent';

export interface CustomIconProps {
  /** Use nav default style */
  isNav?: boolean;
  /** Use nav selected style */
  navSelected?: boolean;
  size?: number;
  /** Adjust vertical position */
  top?: number;
  /** Update color when item (or parent) is hovered */
  hoverHighlight?: boolean;
  /** Fill the icon with solid color */
  color?: string;
}

interface PathProps {
  fillColor: string;
  hoverColor?: string;
}

export const Path = styled.path<PathProps>`
  fill: ${({ fillColor }) => fillColor};
  ${({ hoverColor }) =>
    hoverColor &&
    css`
      svg:hover &,
      .${HOVER_PARENT_CLASSNAME}:hover & {
        fill: ${hoverColor};
      }
    `}
`;

export const Rect = styled.rect<PathProps>`
  fill: ${({ fillColor }) => fillColor};
  ${({ hoverColor }) =>
    hoverColor &&
    css`
      svg:hover &,
      .${HOVER_PARENT_CLASSNAME}:hover & {
        fill: ${hoverColor};
      }
    `}
`;

export const SVG = styled.svg<{ top?: number }>`
  position: relative;
  ${({ top }) =>
    top &&
    css`
      top: ${top}px;
    `}
`;
